/**
 * Account `logo_url` semantics for header branding (nav uses only these three):
 * - empty / null: show account/tenant display name, or "UCS LLC" on non-tenant hosts (App.js)
 * - non-empty URL: show image
 * - "NONE" (case-insensitive, trimmed): hide brand entirely
 */

export function isAccountLogoExplicitlyHidden(logoUrl) {
  if (logoUrl == null) return false;
  const s = String(logoUrl).trim();
  return s.length > 0 && s.toUpperCase() === 'NONE';
}

/** Value suitable for `<img src>`, or null when empty or hidden sentinel */
export function accountLogoImageSrc(logoUrl) {
  if (logoUrl == null) return null;
  const s = String(logoUrl).trim();
  if (s === '' || s.toUpperCase() === 'NONE') return null;
  return s;
}
